import axios from "axios"
import { FiShare2 } from "react-icons/fi"
import { BACKEND } from "../config/configEnvs"
import { useEffect, useRef, useState } from "react"
import Pagination from '@mui/material/Pagination';
import { FaAd, FaExternalLinkAlt, FaEye, FaFilePdf, FaInfoCircle, FaLink, FaMinus, FaSpinner, FaTimes, FaYoutube } from "react-icons/fa";
import { toast } from "react-toastify";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { useSelector } from "react-redux";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import Tooltip from "../components/ui/ToolTip";
import { SiCanva } from "react-icons/si";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import HandleUpdateText from "../utils/HandleUpdateText";
import HandleUpdateSelect from "../utils/HandleUpdateSelect";
import PaginationItem from "../components/ui/components/Pagination";
import Modal from "../components/ui/Modal";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import { FormatDateToDDMMYY } from "../utils/FormatDate";

const RedesClientesAds = () => {

  const user = useSelector((state) => state.auth.user)

  const [clients, setClients] = useState([]) // Clientes

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga
  const [searchText, setSearchText] = useState("") // Barra de búsqueda por texto
  
  const [page, setPage] = useState(1) // Página actual
  const [limit, setLimit] = useState(55) // Límite actual

  const [totalDocs, setTotalDocs] = useState(0) // Total de documentos
  const [totalPages, setTotalPages] = useState(0) // Total de páginas

  const [productFilter, setProductFilter] = useState("") // Filtro de productos
  const [ticketFilter, setTicketFilter] = useState("") // Filtro de tickets

  const [charFilters, setCharFilters] = useState([])

  const characteristics = ["Certificado", "Login", "Cursos"];

  const handleChange = (event) => {
    const { target: { value } } = event
    setCharFilters(typeof value === 'string' ? value.split(',') : value)
  };

  const ITEM_HEIGHT = 48;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
        width: 200,
      },
    },
  };

  const [sortOrder, setSortOrder] = useState(null) // Ordenamiento por el precio mas bajo}

  const handleSortClick = () => {
    setSortOrder((prevOrder) => {
      if (prevOrder === "asc") return "desc";
      if (prevOrder === "desc") return null;
      return "asc";
    });
  };
  
  const [activeAgency, setActiveAgency] = useState(false) // Activo de la agencia

  const [adsServices, setAdsServices] = useState([])

  // Aula virtual, Super Tiendas Virtuales, Landing Page ADS y Web de informativas
  const [serviceFilters, setServiceFilters] = useState(["65777851c1c6ac85e69c879e", "657777afc1c6ac85e69c8771", "657313b7132e0436ce6f7321"])

  const getClients = async () => { // Obtener clientes
    try {
      setLoadingStatus(true)
      let url = `${BACKEND}/api/getClientsByServiceCategory/getAdsClients?limit=${limit}&page=${page}`

      if (searchText) {
        url += `&brandName=${encodeURIComponent(searchText)}`
      }

      if (activeAgency) {
        url += `&activeAgency=${activeAgency}`
      }

      if (productFilter) {
        url += `&productFilter=${productFilter}`
      }

      if (ticketFilter) {
        url += `&ticketFilter=${encodeURIComponent(ticketFilter)}`
      }

      if (sortOrder) {
        url += `&sortOrder=${sortOrder}`
      }

      const response = await axios.post(url, {
        serviceFilters: serviceFilters,
        charFilters: charFilters
      })

      setClients(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
      setLoadingStatus(false)

    } catch (error) {
      toast.error("Error al cargar los clientes: " + error)
    }
  }

  const getAdsServices = async () => { // Obtener los servicios de webs
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?where[categoria][equals]=ADS&limit=0`)
      setAdsServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handlerChangeServiceFilter = (service, checked) => { // Manejador para el selector de servicios
    if (checked) {
      setServiceFilters((prev) => [...prev, service.id])
    } else {
      setServiceFilters((prev) => 
      prev.filter((serviceId) => serviceId !== service.id))
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const handleSearchClients = () => { // Funcion para buscar clientes, automáticamente lleva a la página 1
    getClients()
    setPage(1)
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setSearchText(""); // Cambiar el estado
  };

  const handleResetProductFilter = () => { // Resetea la búsqueda
    setProductFilter(""); // Cambiar el estado
  };

  useEffect(() => { // Se obtienen los clientes al cargar el componente
    getClients()
    getAdsServices()
  }, [])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (searchText === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [searchText]);

  useEffect(() => {
    if (productFilter === "") {
      getClients(); 
      setPage(1); 
    }
  }, [productFilter]);

  useEffect(() => { 
    if (ticketFilter === "") {
      getClients(); 
      setPage(1); 
    }
  }, [ticketFilter]);

  useEffect(() => { // Se piden los clientes cada vez que se actualiza la página o el límite
    getClients()
  }, [page, limit, activeAgency, ticketFilter, sortOrder])

  useEffect(() => {
    const timeout = setTimeout(() => {
      getClients();
    }, 1500);
  
    return () => clearTimeout(timeout); // Limpia el timeout si el efecto se vuelve a ejecutar
  }, [serviceFilters, charFilters]);

  //// Reportes ADS //////

  const [clientNameSelected, setClientNameSelected] = useState("")
  const [reportsModalActive, setReportsModalActive] = useState(false)
  const [serviceSelected, setServiceSelected] = useState({})

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal
        activeModal={reportsModalActive}
        onClose={() => {
          setClientNameSelected("")
          setReportsModalActive(false)
          setServiceSelected({})
        }}
        title={`Reportes Ads de '${clientNameSelected}'`}
        className="max-w-2xl"
        centered
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col border border-gray-200 overflow-y-auto max-h-[40vh] rounded p-1 gap-2">
            {serviceSelected.linkReportes && serviceSelected.linkReportes.length > 0 ? (
              serviceSelected.linkReportes?.map((r) => (
                <div className="flex flex-col gap-2 border border-gray-100 w-full px-2 py-1 shadow hover:bg">

                  <div className="flex flex-row justify-between items-center w-full">
                    <span className="text-xs font-bold">{r.titulo}</span>
                    <span className="text-xs">{FormatDateToDDMMYY(new Date(r.fechaReporte))}</span>
                  </div>

                  <div className="flex flex-row justify-between items-center w-full">
                    <div className="text-xs w-4/5 overflow-hidden text-ellipsis whitespace-nowrap">
                      {r.link}
                    </div>
                    <Tooltip content="Abrir enlace">
                      <a href={r.link} target="_blank" rel="noopener noreferrer">
                        <FaExternalLinkAlt className="text-xs text-blue-500" />
                      </a>
                    </Tooltip>
                  </div>

                </div>
              ))
            ) : (
              <NoDataScreen />
            )}
          </div>
        </div>
      </Modal>

      {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center mb-0.5">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaAd className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Redes clientes ads</h2>
          </div>
        </div>

        <form 
          className="flex flex-row gap-8 items-center justify-center"
          onSubmit={(e) => { e.preventDefault(); handleSearchClients()}}
        >

          <div className="flex flex-row items-center justify-center gap-2">
            <span className="text-xs font-semibold">Límite </span>

            <select 
              name="limit" 
              id="limit"
              className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
            >   
              <option value={25}>25</option>
              <option value={35}>35</option>
              <option value={45}>45</option>
              <option value={55}>55</option>
            </select>
          </div>

          <div className="relative w-full">
            <input
              type="text"
              placeholder="Buscar cliente"
              className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            {searchText && (
              <FaTimes
                onClick={() => handleResetSearch()}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
              />
            )}
          </div>

          <div>
            <Button 
              variant="contained"
              type="submit"
              endIcon={<SearchIcon />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                padding: "4px 24px",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
            >
              Buscar
            </Button>
          </div>

        </form>

      </div>

      {/* Ads services */}     
      <div className="flex flex-row items-center bg-gray-100 mt-0.5 mb-0.5 py-2 px-4">
        <div className="gap-8 w-full overflow-x-auto flex flex-row justify-between items-center">

          <div className="flex flex-row items-center">
            {adsServices.map((service) => (
              <div
                key={service.id}
                className="flex flex-col items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300 last:pr-0 last:border-r-0"
              >
                <div className="flex flex-row items-center justify-center gap-1">
                  <span className="text-xs font-bold">{service.name}</span>
                  <input
                    type="checkbox"
                    className="rounded-md border-gray-400 hover:cursor-pointer"
                    checked={serviceFilters.includes(service.id)}
                    onChange={(e) =>
                      handlerChangeServiceFilter(service, e.target.checked)
                    }
                  />
                </div>
                <div className="flex w-full flex-row items-center px-4 justify-center pt-1 gap-4">
                  <Tooltip content="Review video">
                    <a 
                      href={service.reviewVideo || "#"}
                      target={service.reviewVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={`text-red-500 text-lg ${!service.reviewVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Proyecto video">
                    <a 
                      href={service.proyectVideo || "#"}
                      target={service.proyectVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={`text-red-500 text-lg ${!service.proyectVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Making off video">
                    <a
                      href={service.makingOffVideo || "#"}
                      target={service.makingOffVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={`text-red-500 text-lg ${!service.makingOffVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Casos de éxito">
                    <a
                      href={service.successCaseVideo || "#"}
                      target={service.successCaseVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <SiCanva className={`text-sky-500 text-lg ${!service.successCaseVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Proceso y cronograma">
                    <a 
                      href={service.processCron || "#"}
                      target={service.processCron ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <SiCanva className={`text-sky-500 text-lg ${!service.processCron ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                </div>
              </div>
            ))}
          </div>

          {/* Activo agencia */}
          <div className="flex flex-row items-center justify-center gap-4">
            <span className="text-xs">Activos Agencia</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={activeAgency}
              onChange={(e) => setActiveAgency(e.target.checked)}
            />
          </div>

        </div>
      </div>

      {/* Filtros */}
      {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
        <div className="flex flex-row items-center justify-between bg-gray-100 mt-1 mb-1 px-6">

          {/* Filtro de ticket */}
          <div className="flex flex-row gap-8 items-center justify-center">

            <div className="w-full">
              <select
                type="text"
                placeholder="Filtrar por ticket"
                className="w-[16rem] text-xs text-gray-700 bg-white hover:cursor-pointer border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={ticketFilter}
                onChange={(e) => setTicketFilter(e.target.value)}
              >
                <option value="">Fitlrar por ticket - Todos</option>
                <option value="Bajo: -S/.500">Bajo: -S/.500</option>
                <option value="Normal: S/.800 - S/.3000">Normal: S/.800 - S/.3000</option>
                <option value="Alto: +S/.5000">Alto: +S/.5000</option>
              </select>
            </div>

          </div>

          {/* Filtro de producto */}
          <form 
            className="flex flex-row gap-8 items-center justify-center" 
            onSubmit={(e) => { e.preventDefault(); handleSearchClients()}}
          >
            <div className="relative w-full">
              <input
                type="text"
                placeholder="Filtrar por producto o servicio"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={productFilter}
                onChange={(e) => setProductFilter(e.target.value)}
              />
              {productFilter && (
                <FaTimes
                  onClick={() => handleResetProductFilter()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button 
                variant="contained"
                type="submit"
                endIcon={<FilterAltIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
              >
                Filtrar
              </Button>
            </div>

          </form>

        </div>
      )}
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <div className="flex w-full h-full text-gray-700 items-center justify-center">
            <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                <span>Cargando, por favor espera...</span>
                <FaSpinner className="animate-spin text-gray-500" />
            </div>
          </div>
        ) : (
          clients.length === 0 ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>No hay registros que coincidan con la búsqueda</span>
                  <FaInfoCircle className="text-gray-500" />
              </div>
            </div>
          ) : (
          
          <table className="w-full">
            <thead className="bg-white sticky top-0">
              <tr className="text-gray-700 text-center text-sm uppercase font-semibold">
                <td className="px-2 py-3 max-w-[170px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Cliente
                </td>
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Tel. encargado
                  </td>
                )}
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Tel. gerente
                  </td>
                )}
                <td className="px-6 py-3 max-w-[200px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Nicho y rubro
                </td>
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 max-w-[200px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Datos venta
                  </td>
                )}
                <td className="px-6 py-3 max-w-[200px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Servicio
                </td>
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Venden
                  </td>
                )}
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-2 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    <div className="flex flex-row items-center justify-center gap-2">
                      Precio más bajo
                      <button
                        onClick={handleSortClick}
                        className="bg-white rounded-full text-xs flex items-center justify-center h-5 w-5"
                      >
                        <IconButton aria-label="sort" size="small" className="p-0">
                          {sortOrder === "asc" && <FaAngleUp className="text-red-500 text-xs" />}
                          {sortOrder === "desc" && <FaAngleDown className="text-green-500 text-xs" />}
                          {sortOrder === null && "-"}
                        </IconButton>
                      </button>
                    </div>
                  </td>
                )}
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Ticket del producto
                  </td>
                )}
                {user.area.toUpperCase() === "ADMINISTRACION" && (
                  <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Link Plan de Trabajo
                  </td>
                )}
                {user.area.toUpperCase() === "ADMINISTRACION" && (
                  <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Link Recursos
                  </td>
                )}
                {user.area.toUpperCase() === "ADMINISTRACION" && (
                  <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Link Reportes
                  </td>
                )}
              </tr>
            </thead>

            <tbody>
              {clients.map((client, index) => {

                return (

                  <tr
                    key={index}
                    className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100"
                  >
                    {/* Nombre marca */}
                    <td scope="row" className="px-2 py-2 max-w-[170px] border border-gray-300 truncate hover:cursor-pointer hover:underline transition-all duration-100 font-bold">
                      <a 
                        href={`/home/seguimiento/${client.id}`}
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        {/* {client.nombreComercial} */}
                        {user.area?.toUpperCase() === "COMERCIAL" && user.puesto?.toUpperCase().trim() === "VENDEDOR TEMPORAL"
                          ? (client.encargadoProyecto?.split(" ")[0] || "-")
                          : client.nombreComercial
                        }
                      </a>
                    </td>

                    {/* Número encargado */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                        {client?.telefono}
                      </td>
                    )}

                    {/* Número gerente */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (                    
                      <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                         {client?.telefonoGerente}
                      </td>
                    )}

                    {/* Rubro y nicho */}
                    <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                      {client?.nicho?.name}
                      <br />
                      {client?.nicho?.rubro?.name}
                    </td>
                    
                    {/* Datos venta */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (    
                      <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                        <span className="truncate font-bold">{client?.serviceObj?.cotizacion?.cotizador?.name}</span>
                        <br />
                        <span className="truncate">          
                          {(() => {
                            const precioBase = client?.serviceObj?.customPriceActive
                              ? client?.serviceObj?.customPrice * client?.serviceObj?.numeroItems
                              : client?.serviceObj?.servicio &&
                                client?.serviceObj?.planServicio &&
                                adsServices
                                  .find((e) => e.id === client?.serviceObj?.servicio.id)
                                  .preciosUnitarios.find(
                                    (ev2) => ev2.plan.id === client?.serviceObj?.planServicio.id
                                  )?.precio * client?.serviceObj?.numeroItems;

                            // Calcular el descuento
                            let montoDescuento = 0;
                            if (client?.serviceObj?.tipoDescuento === "Porcentaje") {
                              montoDescuento = precioBase * (client?.serviceObj?.montoDescuento / 100);
                            } else if (client?.serviceObj?.tipoDescuento === "Fijo") {
                              montoDescuento = client?.serviceObj?.montoDescuento;
                            }

                            // Restar el descuento del precio base
                            const precioFinal = precioBase - montoDescuento;

                            // Restar el descuento del precio base
                            return `${precioFinal.toFixed(2)} ${client?.serviceObj?.cotizacion.moneda}`;
                          })()}
                        </span>
                      </td>
                    )}

                    {/* Servicio */}
                    <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                      {client.serviceType}
                    </td>

                    {/* Producto */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 w-[200px] border border-gray-300 truncate text-center">
                        <input 
                          type="text"
                          value={client.productos}
                          placeholder="Buzos, comida, maquinaria, etc"
                          className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                          //onChange={(e) => handleUpdateText("productos", e.target.value, client.id)}
                          onChange={(e) => HandleUpdateText("productos", e.target.value, client.id, "clientesUser", setClients)}
                        />
                      </td>
                    )}
                    
                    {/* Precio mínimo */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 w-[200px] border border-gray-300 truncate text-center">
                        <input 
                          type="number"
                          value={client.precioMin}
                          placeholder="Precio mínimo"
                          className="w-[10rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                          //onChange={(e) => handleUpdateText("precioMin", e.target.value, client.id )}
                          onChange={(e) => HandleUpdateText("precioMin", e.target.value, client.id, "clientesUser", setClients)}

                        />
                      </td>
                    )}
                    
                    {/* Ticket */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 w-[200px] border border-gray-300 truncate text-center">
                        <select 
                          type="text"
                          value={client.ticket}
                          className="w-[10rem] text-xs text-gray-700 bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                          //onChange={(e) => handleUpdateSelect("ticket", e.target.value, client.id)}
                          onChange={(e) => HandleUpdateSelect("ticket", e.target.value, client.id, "clientesUser", setClients)}
                        >
                          <option value="Seleccionar">Seleccionar</option>
                          <option value="Bajo: -S/.500">Bajo: -S/.500</option>
                          <option value="Normal: S/.800 - S/.3000">Normal: S/.800 - S/.3000</option>
                          <option value="Alto: +S/.5000">Alto: +S/.5000</option>
                        </select>
                      </td>
                    )}

                    {/* Link plan trabajo */}
                    {user.area.toUpperCase() === "ADMINISTRACION" && (
                      <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate items-center justify-center text-center">
                        {client.serviceObj?.linkPlanTrabajo ? (
                          <a
                            href={client.serviceObj?.linkPlanTrabajo}
                            className="flex items-center justify-center text-blue-500 underline hover:text-blue-700 transition-colors duration-200 block mx-auto text-ellipsis whitespace-nowrap"
                            target="_blank"
                            rel="noopener noreferrer"
                            title={client.serviceObj?.linkPlanTrabajo}
                          >
                            <FaLink />
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    )}
                    
                    {/* Link recursos */}
                    {user.area.toUpperCase() === "ADMINISTRACION" && (
                      <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate text-center">
                        {client.serviceObj?.linkRecursos ? (
                          <a
                            href={client.serviceObj?.linkRecursos}
                            className="flex items-center justify-center text-blue-500 underline hover:text-blue-700 transition-colors duration-200 block mx-auto text-ellipsis whitespace-nowrap"
                            target="_blank"
                            rel="noopener noreferrer"
                            title={client.serviceObj?.linkRecursos}
                          >
                            <FaLink />
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    )}
                    
                    {/* Link Reportes */}
                    {user.area.toUpperCase() === "ADMINISTRACION" && (
                      <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate text-center">
                        {client.serviceObj?.linkReportes && client.serviceObj?.linkReportes?.length > 0 ? (
                          <div className="flex flex-row items-center justify-center gap-2">
                            <div>
                            <Tooltip content="Abrir último reporte">
                              <a
                                href={client.serviceObj?.linkReportes?.[client.serviceObj?.linkReportes.length - 1]?.link}
                                className="flex justify-start gap-2 items-center p-1 rounded-md cursor-pointer  bg-blue-600 text-blue-700 bg-opacity-10 hover:bg-opacity-20 hover:text-blue-700 hover:border-blue-400 transition duration-200"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <FaExternalLinkAlt />
                              </a>
                            </Tooltip>
                            </div>
                            <div className="">
                              <Tooltip content="Ver todos los reportes">
                                <button
                                  className="flex justify-start gap-2 items-center p-1 rounded-md cursor-pointer  bg-blue-600 text-blue-700 bg-opacity-10 hover:bg-opacity-20 hover:text-blue-700 hover:border-blue-400 transition duration-200"
                                  onClick={() => {
                                    setReportsModalActive(true)
                                    setServiceSelected(client.serviceObj)
                                    setClientNameSelected(client.nombreComercial)
                                  }}
                                >
                                  <FaEye />
                                </button>
                              </Tooltip>
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                    )}

                  </tr>
                )
              })}

            </tbody> 
          </table>
          )
        )}
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={clients.length}
        totalDocs={totalDocs}
        entity={"clientes"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  )

}

export default RedesClientesAds